<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div v-if="userPermissions.indexOf('add_contact_extension') > -1" class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="socialMediaForm">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="userId">User :</div>
                                </div>
                                <template v-if="contact_type != 'other'">
                                    <div class="col-9 paddingleft0">
                                        <v-select v-model="userId"
                                                  @change="changedValue"
                                                  @input="changedValueUser()"
                                                  name="userId"
                                                  id="userId"
                                                  label="text"
                                                  :filterable="false"
                                                  :options="userArr"
                                                  @search="onSearchUser"
                                                  placeholder="Select User">
                                            <template slot="no-options">
                                                Search User...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="requiredstar">*</div>
                                        <font class="text-danger">{{userIdError}}</font>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="col-9 paddingleft0">
                                        <input v-model="userId" class="form-control" id="userId" placeholder="User Name"  maxlength="190" />
                                        <div class="requiredstar">*</div>
                                        <font class="text-danger">{{userIdError}}</font>
                                    </div>
                                </template>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="userPost">Post :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="userPost" type="text" class="form-control" id="userPost" placeholder="Post"  maxlength="190" />
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="company">Company :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span class="form-control" >{{companyName}}</span>
                                </div>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="siteid">Location :</div>
                                </div>
                                <!--<template v-if="contact_type == ''">
                                    <div class="col-9 paddingleft0">
                                        <span class="form-control" >{{siteid.text}}</span>
                                    </div>
                                </template>-->
                                <template>
                                    <div class="col-9 paddingleft0">
                                        <v-select v-model="siteid"
                                                  @change="changedValuest"
                                                  @input="changedValueSite()"
                                                  name="siteid"
                                                  id="siteid"
                                                  label="text"
                                                  :clearable="false"
                                                  :filterable="false"
                                                  :searchable="false"
                                                  :options="sitesArr"
                                                  @search="onSearchSite"
                                                  placeholder="Select Location">
                                            <template slot="no-options">
                                                Search State...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="requiredstar">*</div>
                                        <font class="text-danger">{{siteidError}}</font>
                                    </div>
                                </template>
                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="departmentId">Department :</div>
                                </div>
                                <!--<template v-if="contact_type == ''">
                                    <div class="col-9 paddingleft0">
                                        <span class="form-control" >{{departmentId.text}}</span>
                                    </div>
                                </template>-->
                                <template>
                                    <div class="col-9 paddingleft0">
                                        <v-select class=""
                                                  v-model="departmentId"
                                                  @input="changedValueDept()"
                                                  name="departmentId"
                                                  id="departmentId"
                                                  label="text"
                                                  :clearable="false"
                                                  :searchable="false"
                                                  :filterable="false"
                                                  :options="departmentArr"
                                                  placeholder="Select Department">
                                        </v-select>
                                        <div class="requiredstar">*</div>
                                        <font class="text-danger">{{departmentIdError}}</font>
                                    </div>
                                </template>

                            </div>
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="extension">Extension :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="extension" type="text" class="form-control" id="extension" placeholder="Extension"  maxlength="190" />
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{extensionError}}</font>                                    
                                </div>
                            </div>
                            <!--Created BY-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" >{{createdByTitle}} :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <span class="form-control" id="createdBy">{{createdBy}}</span>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="useremail">Email :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="useremail" class="form-control" id="useremail" placeholder="User Email"  maxlength="190" />
                                    <font class="text-danger">{{useremailError}}</font>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-12 paddingleft0">
                                    <div class="form-label" >Contact</div>
                                </div>
                            </div>
                            <div v-if="contacts.length < plusCount" class="col-12 forms-block">
                                <div class="col-1 paddingleft0">
                                    <button type="button" v-on:click="addNewContactInputs" class="btn btn-block btn-success">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                                <div class="mt-2 col-11 paddingleft0">
                                    Would you like add more Contacts?
                                </div>
                            </div>
                            <div class="row col-12" v-for="(contactGroup, index) in contacts">
                                <div class="col-12 forms-block">
                                    <div class="col-1 paddingleft0">
                                        <button type="button" v-on:click="removeContact(index)" class="btn btn-block btn-danger">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    <div class="col-11 paddingleft0">
                                        <div class="col-6 paddingleft0">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label" >Contact Label :</div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input v-model="contactGroup.contact_label" type="text"
                                                       name="contacts[][contact_label]" class="form-control" placeholder="Contact Label">
                                            </div>
                                        </div>
                                        <div class="col-6 paddingleft0">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label">Contact :</div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input v-model="contactGroup.contact" type="text"
                                                       name="contacts[][contact]" class="form-control" placeholder="Contact"  maxlength="190">
                                                <div class="requiredstar">*</div>
                                                <font class="text-danger" :id="'contact_'+index"></font> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--Address Line-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="addressLine">Address Line :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <textarea v-model="addressLine" class="form-control" id="addressLine" placeholder="Address Line"></textarea>
                                </div>
                            </div>
                            <!--Note-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="note">Contact Note :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <textarea v-model="note" class="form-control" id="note" placeholder="Contact Note"></textarea>
                                </div>
                            </div>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addContactBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addContact()">
                                    <input id="addAndContinueContactBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addContact(flag='Save and Continue')">
                                    <input id="CancelContactBtn" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <div v-else class="container-fluid xyz">
            <div class="page-name">
                Oops...!
            </div>
            <div class="admin-page-content">
                Sorry, You don't have permission to access this page.
            </div>
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';
    import EventBus from '../../event-bus';

    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    export default {
        name: 'AddContact',
        pageTitle: 'Add User Contact',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            'datePicker': datePicker,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                editID: 0,
                contact_type: "",
                isShowLoggedinfields: true,
                userPermissions: ['add_contact_extension'],
                roleId: 0,
                roleName: 0,
                system_year: '',
                createdByTitle: '',
                createdBy: '',
                pageTitle: '',
                addressLine: '',
                note: '',
                siteid: '',
                sitesArr: [],
                companyName: '',
                contactPerson: '',
                departmentId: '',
                departmentIdError: '',
                departmentArr: [],
                userId: '',
                userIdError: '',
                extension: '',
                extensionError: '',
                userPost: '',
                useremail: '',
                useremailError: '',
                userArr: [],
                contact: {
                    contact_label: '',
                    contact: '',
                },
                contacts: [{
                        contact_label: '',
                        contact: '',
                    }
                ],
                //Errors
                contactError: '',
                siteidError: '',
                plusCount: 20,
                isUserChange: false,
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            var path = window.location.pathname;
            var segments = path.split("/");
            var userType = "";

            var userObj = localStorage.getItem("user_obj");
            var userJson = [];
            if (userObj != null) {
                userJson = JSON.parse(userObj);
            } else {
                self.$router.push("/login");
            }
            self.loadSite();
            if (segments[2] == 'updatecontact') {
                if (segments[3]) {
                    self.createdByTitle = 'Update By';
                    self.pageTitle = 'Edit User Contact';
                    self.loadContact();
                    $("#addAndContinueContactBtn").hide();
                    $("#addContactBtn").val("Update");
                }
            } else {
                self.createdByTitle = 'Created By';
                self.pageTitle = 'Add User Contact';
                self.createdBy = userJson.first_name + " " + userJson.last_name;
                userType = self.$route.query.type;
                if (userType === null || typeof userType === "undefined" || userType == '') {
                    self.buttonBack();
                }
                if (userType == 'non-employee') {
                    self.contact_type = "other";
                }
            }
            /*console.log("User Type : " + self.contact_type);*/
            $("#contact").on('keyup', function () {
                self.contactError = '';
            });
            $("#siteid").on('keyup', function () {
                self.siteidError = '';
            });
            $("#departmentId").on('keyup', function () {
                self.departmentIdError = '';
            });
            $("#extension").on('keyup', function () {
                self.extensionError = '';
            });
            $("#useremail").on('keyup', function () {
                self.useremailError = '';
            });
            $("#alertError").hide();
            self.getPermissions();
        },
        watch: {
            siteid: function (siteid) {
                let self = this;
                self.departmentArr = [];
                self.companyName = "";
                if (siteid != null) {
                    $.each(self.sitesArr, function (i) {
                        if (siteid.value == self.sitesArr[i].value) {
                            self.companyName = self.sitesArr[i].company;
                        }
                    });
                    if (self.contact_type == 'other') {
                        self.departmentId = '';
                    }

                    if (self.isUserChange) {
                        self.isUserChange = false;
                    } else {
                        self.departmentId = '';
                    }
                    self.loadDepartment(siteid.value)
                }/* else {
                 self.loadSite();
                 }*/
            },
            departmentId: function (departmentId) {
                if (self.contact_type != 'other') {
                    if (departmentId === null || typeof departmentId.value === "undefined" || departmentId.value === null || departmentId.value == '') {
                    } else {
                        let self = this;
                        self.loadUsersOnChange();
                    }
                }
            },
            userId: function (userId) {
                var self = this;
                if (self.contact_type != 'other') {
                    if (userId === null || typeof userId.value === "undefined" || userId.value === null || userId.value == '') {
                    } else {
                        self.isUserChange = true;

                        var path = window.location.pathname;
                        var segments = path.split("/");
                        if (segments[2] == 'updatecontact') {
                            if (segments[3]) {
                                self.siteid = {'text': userId.location_name, 'value': userId.location_id};
                                self.departmentId = {'text': userId.department_name, 'value': userId.department_id};
                            }
                        }
                    }
                }
            },
            /*userId: function (userId) {
             if (userId === null || typeof userId.value === "undefined" || userId.value === null || userId.value == '') {
             } else {
             let self = this;
             self.loadUsersOnChange();
             }
             }*/
            /*userId: function (userId) {
             let self = this;
             if (self.userId === null || typeof self.userId.value === "undefined" || self.userId.value === null || self.userId.value == '') {
             } else {
             var config = {
             headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
             params: {
             user_id: self.userId.value,
             }
             };
             HTTP.get("checkusercontact", config)
             .then(function (response) {
             if (response.data.status == "success") {
             self.$swal('Cancelled', response.data.message, 'info')
             self.userId = '';
             }
             })
             .catch(function (err) {
             if (err.response.status == 0) {
             self.error = "Remote server can not be reachable";
             } else {
             //redirect to login page if user not authenticated
             if (err.response.status == 401) {
             //clear previous data
             localStorage.removeItem("user_obj");
             localStorage.removeItem("api_token");
             localStorage.removeItem("profile_image");
             //EventBus.$emit("logged-in", true, "", "");
             self.$router.push("/login");
             }
             self.error = err.response.data.message;
             }
             });
             }
             }*/
        },
        methods: {
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/contactextensionlist');
            },
            addNewContactInputs: function () {
                if (self.contacts.length < self.plusCount) {
                    self.contacts.push(Vue.util.extend({}, self.contact))
                }
            },
            removeContact: function (index) {
                Vue.delete(self.contacts, index);
            },
            changedValue: function (value) {
                /*console.log("on User Change");
                 console.log(value);*/
            },
            changedValuest: function (value) {
                //console.log(value);
            },
            changedValueSite: function () {
                self.siteidError = "";
            },
            changedValueDept: function () {
                self.departmentIdError = "";
            },
            changedValueUser: function () {
            },
            onSearchSite(search, loading) {
                if (search.length > 1) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadSite(loading, search, this);
                }
            },
            onSearchUser(search, loading) {
                let self = this;
                /*if (self.siteid != null && self.siteid != "") {*/
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    self.loadUsers(loading, search, this);
                }
                /*}*/
            },
            checkForm: function () {
                var checked = true;
                /*self.contactError = "";
                 if (!self.contact) {
                 self.contactError = "Contact Required";
                 if (checked) {
                 checked = false;
                 }
                 } else if (self.contact.length > 190) {
                 self.contactError = "Title cannot be longer than 190 character";
                 if (checked) {
                 checked = false;
                 }
                 }*/
                self.userIdError = "";
                if (!self.userId) {
                    self.userIdError = "User Is Required";
                    if (checked) {
                        checked = false;
                    }
                }
                self.siteidError = "";
                if (!self.siteid) {
                    self.siteidError = "Location Required";
                    if (checked) {
                        checked = false;
                    }
                }
                self.departmentIdError = "";
                if (!self.departmentId) {
                    self.departmentIdError = "Department Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.contact_type != '') {
                    self.useremailError = "";
                    if (self.contact_type == "other") {
                        /*if (self.useremail == '') {
                         self.useremailError = "Email Required";
                         if (checked) {
                         checked = false;
                         }
                         } else */if (self.useremail != '' && !self.validEmail(self.useremail)) {
                            self.useremailError = 'Please Enter Valid Email';
                            if (checked) {
                                checked = false;
                            }
                        }
                    } else {
                        if (self.useremail == '') {
                            self.useremailError = "Email Required";
                            if (checked) {
                                checked = false;
                            }
                        } else if (self.useremail != '' && !self.validEmail(self.useremail)) {
                            self.useremailError = 'Please Enter Valid Email';
                            if (checked) {
                                checked = false;
                            }
                        }
                    }
                }
                self.extensionError = "";
                if (self.extension == "") {
                    self.extensionError = "Extension Required";
                    if (checked) {
                        checked = false;
                    }
                }
                /* else if (!self.checkExtension(self.extension)) {
                 self.extensionError = 'Please Enter Valid Extension Number';
                 if (checked) {
                 checked = false;
                 }
                 }*/

                /*self.userPostError = "";
                 if (self.userPost == "") {
                 self.userPostError = "Post Required";
                 if (checked) {
                 checked = false;
                 }
                 }*/
                $.each(self.contacts, function (i) {
                    $("#contact_" + i).html('');
                    if (self.contacts[i].contact == "") {
                        $("#contact_" + i).html("Contact Required");
                        if (checked) {
                            checked = false;
                        }
                    } /*else if (!self.checkContact(self.contacts[i].contact)) {
                     $("#contact_" + i).html('Please Enter Valid Contact Number');
                     if (checked) {
                     checked = false;
                     }
                     }*/
                });
                /* self.extensionError = "";
                 if (self.extension && (!self.validPhoneOrExtension(self.extension))) {
                 self.extensionError = "Please Enter Valid Extension";
                 if (checked) {
                 checked = false;
                 }
                 } */
                return checked;
            },
            validPhoneOrExtension: function (number) {
                // var rePhone = /^((\+)?(\d{2}[-]))?(\d{10}){9}?$/;
                var rePhone = /^((\+)?([0-9][-]))?([0-9]){9}?$/;
                // var rePhone = /^((\+)?(\d{1,3}[-]))?(\d{10,20}[,])$/;
                // var rePhone = /^\+\d{1,3}-\d{5,20},$/;
                // var rePhone = /^[\+][-][89][0-9]{9}/;
                return rePhone.test(number);
            },
            checkExtension: function (contact) {
                var re = /^(?=.*[0-9])[- +(),0-9]+$/;
                return re.test(contact);
            },
            checkContact: function (contact) {
                var re = /^(?=.*[0-9])[- +()0-9]+$/;
                return re.test(contact);
            },
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            loadContact() {
                var userJson = [];
                var userObj = localStorage.getItem("user_obj");
                if (userObj != null) {
                    userJson = JSON.parse(userObj);
                } else {
                    self.$router.push("/login");
                }
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        id: segments[3],
                    }
                };
                HTTP.get("loadcontact", config)
                        .then(function (response) {
                            self.editID = response.data.content.id;
                            /*if (response.data.content.user_type == 'other') {*/
                            self.contact_type = response.data.content.user_type;
                            /*}*/
                            if (self.contact_type == 'other') {
                                self.siteid = {'text': response.data.content.site_name, 'value': response.data.content.site_id};
                            }
                            self.companyName = "";
                            setTimeout(function () {
                                if (self.contact_type == 'other') {
                                    self.useremail = response.data.content.contact_email;
                                    self.departmentId = {'text': response.data.content.department_name, 'value': response.data.content.department_id};
                                    self.userId = response.data.content.user;
                                } else {
                                    self.useremail = response.data.content.contact_email;
                                    self.userId = (response.data.content.userid != '') ? {
                                        'text': response.data.content.user,
                                        'value': response.data.content.userid,
                                        'location_id': response.data.content.site_id,
                                        'location_name': response.data.content.site_name,
                                        'department_id': response.data.content.department_id,
                                        'department_name': response.data.content.department_name,
                                    } : '';
                                }
                                var userType = response.data.content.userid.split('||');
                                self.companyName = response.data.content.company;
                                self.extension = response.data.content.contact;
                                self.userPost = response.data.content.post;
                                self.addressLine = response.data.content.address_line;
                                self.note = response.data.content.note;
                                self.contacts = response.data.content.contact_details;
                                self.createdBy = userJson.first_name + " " + userJson.last_name;
                            }, 300);
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            addContact(flag) {
                self.checkForm();
                if (self.checkForm()) {
                    var userJson = [];
                    var userObj = localStorage.getItem("user_obj");
                    if (userObj != null) {
                        userJson = JSON.parse(userObj);
                    } else {
                        self.$router.push("/login");
                    }
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    let deptID = (self.departmentId === null || typeof self.departmentId.value === "undefined" || self.departmentId.value === null || self.departmentId.value == '') ? '' : self.departmentId.value;
                    var UseID = '';
                    if (self.contact_type != 'other') {
                        UseID = (self.userId === null || typeof self.userId.value === "undefined" || self.userId.value === null || self.userId.value == '') ? '' : self.userId.value;
                    } else {
                        UseID = (self.userId === null || typeof self.userId === "undefined" || self.userId == '') ? '' : self.userId;
                        UseID += '||' + self.contact_type;
                    }
                    var data = {};
                    data.location = self.siteid.value;
                    data.extension = self.extension;
                    data.user_post = self.userPost;
                    data.department_id = deptID;
                    data.user_id = UseID;
                    data.email = self.useremail;
                    data.addressline = self.addressLine;
                    data.note = self.note;
                    data.contact = self.contacts;
                    if (segments[2] == 'updatecontact') {
                        if (self.editID) {
                            data.id = self.editID;
                            $("#addContactBtn").val("Updating ...");
                            $("#addContactBtn").prop("disabled", true);
                            $("#CancelContactBtn").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueContactBtn").val("Saving ...");
                                $("#addAndContinueContactBtn").prop("disabled", true);
                                $("#addContactBtn").prop("disabled", true);
                                $("#CancelContactBtn").prop("disabled", true);
                            } else {
                                $("#addContactBtn").val("Saving ...");
                                $("#addContactBtn").prop("disabled", true);
                                $("#addAndContinueContactBtn").prop("disabled", true);
                                $("#CancelContactBtn").prop("disabled", true);
                            }
                        }
                    } else {
                        if (flag == "Save and Continue") {
                            $("#addAndContinueContactBtn").val("Saving ...");
                            $("#addAndContinueContactBtn").prop("disabled", true);
                            $("#addContactBtn").prop("disabled", true);
                            $("#CancelContactBtn").prop("disabled", true);
                        } else {
                            $("#addContactBtn").val("Saving ...");
                            $("#addContactBtn").prop("disabled", true);
                            $("#addAndContinueContactBtn").prop("disabled", true);
                            $("#CancelContactBtn").prop("disabled", true);
                        }
                    }
                    HTTP.post("addupdatecontact", data, config)
                            .then(function (response) {
                                if (segments[2] == 'updatecontact') {
                                    if (self.editID) {
                                        $("#addContactBtn").val("Update");
                                        $("#addContactBtn").prop("disabled", false);
                                        $("#CancelContactBtn").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueContactBtn").val("Save and Continue");
                                            $("#addAndContinueContactBtn").prop("disabled", false);
                                            $("#addContactBtn").prop("disabled", false);
                                            $("#CancelContactBtn").prop("disabled", false);
                                        } else {
                                            $("#addContactBtn").val("Save");
                                            $("#addContactBtn").prop("disabled", false);
                                            $("#addAndContinueContactBtn").prop("disabled", false);
                                            $("#CancelContactBtn").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueContactBtn").val("Save and Continue");
                                        $("#addAndContinueContactBtn").prop("disabled", false);
                                        $("#addContactBtn").prop("disabled", false);
                                        $("#CancelContactBtn").prop("disabled", false);
                                    } else {
                                        $("#addContactBtn").val("Save");
                                        $("#addContactBtn").prop("disabled", false);
                                        $("#addAndContinueContactBtn").prop("disabled", false);
                                        $("#CancelContactBtn").prop("disabled", false);
                                    }
                                }

                                if (response.data.message == "success") {
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    if (flag == "Save and Continue") {
                                        $(".alert-success").addClass("show");
                                        self.siteid = '';
                                        self.extension = '';
                                        self.userPost = '';
                                        self.departmentId = '';
                                        self.userId = '';
                                        self.useremail = '';
                                        self.addressLine = '';
                                        self.note = '';
                                        self.contacts = [{contact_label: '', contact: '', }];
                                        self.createdBy = userJson.first_name + " " + userJson.last_name;
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                            })
                            .catch(function (err) {
                                if (segments[2] == 'updatecontact') {
                                    if (self.editID) {
                                        $("#addContactBtn").val("Update");
                                        $("#addContactBtn").prop("disabled", false);
                                        $("#CancelContactBtn").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueContactBtn").prop("disabled", false);
                                            $("#addAndContinueContactBtn").val("Save and Continue");
                                            $("#addContactBtn").prop("disabled", false);
                                            $("#CancelContactBtn").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            self.siteid = '';
                                            self.extension = '';
                                            self.userPost = '';
                                            self.departmentId = '';
                                            self.userId = '';
                                            self.useremail = '';
                                            self.addressLine = '';
                                            self.note = '';
                                            self.contacts = [{contact_label: '', contact: '', }];
                                            self.createdBy = userJson.first_name + " " + userJson.last_name;
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addContactBtn").val("Save");
                                            $("#addContactBtn").prop("disabled", false);
                                            $("#addAndContinueContactBtn").prop("disabled", true);
                                            $("#CancelContactBtn").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueContactBtn").prop("disabled", false);
                                        $("#addAndContinueContactBtn").val("Save and Continue");
                                        $("#addContactBtn").prop("disabled", false);
                                        $("#CancelContactBtn").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        self.siteid = '';
                                        self.extension = '';
                                        self.userPost = '';
                                        self.departmentId = '';
                                        self.userId = '';
                                        self.useremail = '';
                                        self.addressLine = '';
                                        self.note = '';
                                        self.contacts = [{contact_label: '', contact: '', }];
                                        self.createdBy = userJson.first_name + " " + userJson.last_name;
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addContactBtn").val("Save");
                                        $("#addContactBtn").prop("disabled", false);
                                        $("#addAndContinueContactBtn").prop("disabled", true);
                                        $("#CancelContactBtn").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                            });
                }
            },
            loadSite(loading, search, vm) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        search: search,
                        get_all: 1
                    }
                };
                HTTP.get("ce-getsite", config)
                        .then(function (response) {
                            self.sitesArr = [];
                            $.each(response.data.content, function (i) {
                                /*if (i == 0) {
                                 self.siteid = response.data.content[i];
                                 }*/
                                self.sitesArr.push(response.data.content[i]);
                            });
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadDepartment(id) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        site: id,
                    }
                };
                HTTP.get("ce-getdepartment", config)
                        .then(function (response) {
                            self.departmentArr = [];
                            $.each(response.data.content, function (i) {
                                /*if (i == 0) {
                                 self.departmentId = response.data.content[i];
                                 }*/
                                self.departmentArr.push(response.data.content[i]);
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadUsers(loading, search, vm) {
                let self = this;
                let siteId = "";
                let departmentId = "";
                if (self.siteid != null && self.siteid != "") {
                    siteId = self.siteid.value;
                }
                if (self.departmentId != null && self.departmentId != "") {
                    departmentId = self.departmentId.value;
                }
                siteId = "";
                departmentId = "";
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        search: search,
                        site_id: siteId,
                        department_id: departmentId,
                    }
                };
                HTTP.get("getallusers", config)
                        .then(function (response) {
                            self.userArr = [];
                            $.each(response.data.content, function (i) {
                                self.userArr.push(response.data.content[i]);
                            });
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadUsersOnChange() {
                let self = this;
                let siteId = "";
                let departmentId = "";
                if (self.siteid != null && self.siteid != "") {
                    siteId = self.siteid.value;
                }
                if (self.departmentId != null && self.departmentId != "") {
                    departmentId = self.departmentId.value;
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        search: '',
                        site_id: siteId,
                        department_id: departmentId,
                    }
                };
                HTTP.get("getallusers", config)
                        .then(function (response) {
                            self.userArr = [];
                            $.each(response.data.content, function (i) {
                                /*if (i == 0) {
                                 self.userId = response.data.content[i];
                                 }*/
                                self.userArr.push(response.data.content[i]);
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        }
    }
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/backend/contactextension/AddContact.vue